import { createSlice } from "@reduxjs/toolkit";
// import { useSelector } from "react-redux";
import { findUser } from "../../features/loginFeature/Services/LoginMockAPI";
// import { useNavigate } from "react-router-dom";


// const initialUserValue = {
//     isLoading:false,
//     user:{
//         id:'',
//         first_name:"",
//         last_name:"",
//         userName:"",
//         passwrd:""
//     },
//     error:''
// }

const userValue = {
    isLoading:false,
    isLoggedIn:false,
    user:{
        id:'',
        first_name:"",
        last_name:"",
        userName:"",
        passwrd:""
    },
    error:''
}


export const userSlice = createSlice({
    name:'user',
    initialState:{
        // value:{
            userValue,
        // },
    },
    reducers:{
        login:(state,action)=>{
            console.log(action.payload)
            state.value = action.payload;
        },
        logging_user_in:(state,action)=>{
            console.log("in logging user in");
            state.userValue ={
                ...state.userValue,
                isLoading:true
            }

            
            // console.log(state.userValue)
        },
        log_user_in_success:(state,action)=>{
            console.log("in logging user in success");
            state.userValue ={
                ...state.userValue,
                isLoading:false,
                isLoggedIn:true,
                error:"",
                user:action.payload
            }

            

        },
        log_user_in_unsuccessful:(state,action)=>{
            console.log("in logging user in unsuccessful");
            state.userValue ={
                ...state.userValue,
                isLoading:false,
                error:"incorrect login"
            }
        },
        log_out_user:(state,action)=>{
            state.userValue = {
                userValue
            }
        }

    }
})


export const {
    login,
    logging_user_in,
    log_user_in_success,
    log_user_in_unsuccessful,
    log_out_user} = userSlice.actions;


// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
export const incrementAsync = (incomingUserInfo) => (dispatch) => {
    // console.log(incomingUserInfo);
    dispatch(logging_user_in())
    // console.log(selectCount())
    // selectCount(store.getState())
    // console.log(useSelector((state) => state.counter.value))
    setTimeout(() => {
    //   dispatch()
        console.log("in thunk function");
        let foundUser = findUser(incomingUserInfo.username,incomingUserInfo.passwrd);
        // console.log(foundUser)
        if(foundUser){
            dispatch(log_user_in_success(foundUser));
        }else{
            dispatch(log_user_in_unsuccessful())
        }
        // dispatch(login(incomingUserInfo))
    //   incrementByAmount(amount)
    }, 1000)
  }


  export const loginUser = (incomingUserInfo) => (dispatch)=>{
    console.log(incomingUserInfo);
    dispatch(logging_user_in())

    setTimeout(()=>{
        console.log("timing out")
    },1000)
  }

  
  // The function below is called a selector and allows us to select a value from
  // the state. Selectors can also be defined inline where they're used instead of
  // in the slice file. For example: `useSelector((state) => state.counter.value)`
  export const selectCount = (state) => state

export default userSlice.reducer;






   // state.value ={
            //     ...state.value.initialUserValue,
            //     isLoading:true
            // }

            // state.value ={
            //     ...state.value,
            //     initialUserValue{

            //     }
            //     isLoading:true
            // }


            // setInspectionAgencyObject({
            //     ...inspectionAgencyObjct,
            //     inspector_headquarter_address:{
            //       ...inspectionAgencyObjct.inspector_headquarter_address,
            //       address:e.target.value
            //     }
            //   });